import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  QuestionnaireActiveFormField,
  QuestionnaireActiveOption
} from './active.interface';
import { QuestionnaireActiveState } from './active.state';

export const QuestionnaireActiveActions = createActionGroup({
  source: 'Questionnaire Active',
  events: {
    Reset: emptyProps(),

    // Setters State
    'Set Active': props<{ active: boolean }>(),
    'Set Form': props<{
      key: QuestionnaireActiveFormField;
      value:
        | Array<QuestionnaireActiveOption>
        | QuestionnaireActiveOption
        | number
        | string
        | null;
    }>(),
    'Set Loading': props<{
      key: keyof QuestionnaireActiveState['loading'];
      value: boolean;
    }>(),
    'Set User Profile': props<{
      value: QuestionnaireActiveState['userProfile'];
    }>(),
    'Set Submission Response':
      props<QuestionnaireActiveState['submissionResponse']>(),

    // Fetching
    'Fetch User Profile': emptyProps(),

    // Mutations
    Submit: emptyProps()
  }
});
